<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="viewedByOwner" dark icon title="View in My Attendance" @click="viewInMyAttendance">
                        <v-icon>access_time</v-icon>
                    </v-btn>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>

                    <v-menu v-if="showMenu" left v-model="menu_status" offset-y :disabled="isMenuDisabled">
                        <template v-slot:activator="{ on }">
                            <v-btn :color="commonfn.getStatusButtonColor(attendance_corrections.status)" dark v-on="on" :loading="loading_status" class="mr-0">
                                <span class="ml-7">{{ commonfn.getStatusDescription(attendance_corrections.status) }}</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item, index) in menuItems" :key="index" @click="item.action">
                                <v-list-tile-title small>{{ item.label }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <!-- fallback -->
                    <v-btn v-else-if="!loading && attendance_corrections" :color="commonfn.getStatusButtonColor(attendance_corrections.status)" dark class="mr-0">
                        {{ commonfn.getStatusDescription(attendance_corrections.status) }}
                    </v-btn>
                </v-toolbar>
            </v-card>

            <v-alert v-if="!loading&&approved_Timesheet" :value="true" color="warning" icon="warning" outline class="mt-8">
                The timesheet for this period is already <b>Approved</b>. You will not be able to change this record.
            </v-alert>
           
            <!-- details -->
            <v-layout v-if="!loading" row wrap>
                <v-flex xs12>
                    <v-card class="elevation-1 transparent">
                        <v-toolbar flat height="45px" class="font-weight-bold">
                            <span class="primary--text">ATTENDANCE CORRECTIONS DETAILS</span>
                            <v-spacer></v-spacer>
                            <help-link appId="attendance" :pageId="helpPageId" color="black"></help-link>
                        </v-toolbar>
                        <v-layout v-if="attendance_corrections" row wrap> 
                            <v-flex xs12 sm6>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row mt-5'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Requested By :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        <v-chip @click="viewUserProfile(attendance_corrections, $store.state.userId)" class="user-chip-container">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(attendance_corrections.userId)"></v-img>
                                            </v-avatar>
                                            {{attendance_corrections.firstName}} {{attendance_corrections.lastName}}
                                        </v-chip>
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Date :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.transDate|moment('dddd, DD MMM YYYY')}}
                                    </v-flex>  
                                </v-layout>                        
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        New Clock In : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.clockIn|moment('hh:mm a')}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        New Clock Out : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.clockOut|moment('hh:mm a')}}
                                    </v-flex>  
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="attendance_corrections" row wrap> 
                            <v-flex xs12 sm6>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Work Shift :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.clockStart|moment('hh:mm a')}} to {{attendance_corrections.clockEnd|moment('hh:mm a')}} {{getWorkshiftType(attendance_corrections.strict)}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Original Clock In : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        <span v-if="original_attendance!=null">
                                            <span v-if="original_attendance.clockIn!=null">{{original_attendance.clockIn|moment('hh:mm a')}}</span>
                                            <span v-else>None</span>
                                        </span>
                                        <span v-else>None</span>
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Original Clock Out : 
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        <span v-if="original_attendance!=null">
                                            <span v-if="original_attendance.clockOut!=null">{{original_attendance.clockOut|moment('hh:mm a')}}</span>
                                            <span v-else>None</span>
                                        </span>
                                        <span v-else>None</span>
                                    </v-flex>  
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Total Hours :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.totalHours}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Chargeable Hours :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{attendance_corrections.chargeableHours}}
                                    </v-flex>  
                                </v-layout>
                                <v-layout row wrap :class="isMobile? 'content-row-mobile' : 'content-row'"> 
                                    <v-flex xs4 class="text-xs-left">
                                        Remarks :
                                    </v-flex>
                                    <v-flex xs8 class="font-weight-bold text-xs-left mb-5">
                                        {{attendance_corrections.remarks}}
                                    </v-flex>  
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="!attendance_corrections" row wrap>
                            <v-flex xs12>
                                <p class="ml-20">Record not found.</p>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>

            <!-- attachments -->
            <v-card v-if="!loading && attendance_corrections" class="elevation-1 mt-5 mb-5"> 
                <v-toolbar flat height="35px">
                    <span class="font-weight-bold primary--text">ATTACHMENTS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="enableForEditRights" icon title="Add Attachments" @click="showUpload">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="attachments"
                    :hide-actions="attachments.length<6"
                    :loading="loading_attachment"
                >
                    <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                    <template v-slot:items="props">
                        <tr>
                            <td @click="previewAttachment(props.item)" title="Click to preview file">
                                <div class="clickable wrapped-filename">
                                    {{ props.item.fileName }}
                                </div>
                            </td>
                            <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                            <td>
                                <v-btn v-if="enableForEditRights" icon title="Delete Attachment" @click="showDeleteAttachment(props.item)" :disabled="loading_attachment">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td> 
                        </tr>
                    </template>
                </v-data-table> 
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap v-if="attendance_corrections">
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>    
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="attendanceCorrectionsId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteHandler"></delete>
        </v-dialog>
        <v-dialog v-model="dialogAttendanceCorrections" width="600" persistent>   
            <att-corrections ref="addAttCorrections" @send="getAttendanceCorrectionsById(false)" :dialogAttendanceCorrections.sync="dialogAttendanceCorrections"></att-corrections>
        </v-dialog>
        <v-dialog v-model="dialogUpload" fullscreen hide-overlay transition="dialog-bottom-transition"> 
            <upload ref="uploadRef" :dialogUpload.sync="dialogUpload" @send="getAttendanceCorrectionsById(false)"></upload>
        </v-dialog>
        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogTeamSelector" width="700">
            <team-selector :teams="matchingTeams" :dialogTeamSelector.sync="dialogTeamSelector"></team-selector>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="attendanceCorrectionsId" @refresh="updateHandler"></status-messaging>
    </v-layout>  
</template>

<script>

import { syncTeamContext } from '@/helpers/team-selector'
import commonfn from '@/common/functions' //for refactor
import AppPageID from '@/constants/app_page_ids'
import attCorrectionsApi from '@/api/attendancecorrection'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import { hasEditRights, hasDeleteRights } from '@/helpers/access-permissions'
import { hasTeamEditRights, hasTeamDeleteRights, hasTeamApproverRights, hasTeamSelfApproverRights } from '@/helpers/myteams-permissions'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'Attendance Corrections',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View attendance corrections details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'att-corrections': () => import('@/components/Attendance/AttendanceCorrections'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'delete': () => import('@/components/BasicPopups/Delete'),
        'upload': () => import('@/components/AttendanceCorrections/AddAttachments'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'team-selector': () => import('@/components/Team/TeamSelector')
    },   
    data () {
        return {
            commonfn,
            awsS3Helper,
            error: false,
            errorMessage: '',
            loading: false,
            loading_delete: false,
            loading_status: false,
            loading_attachment: false,
            menu_status: false,
            dialogUpload: false,
            dialogPreview: false,
            headers: [
                {text: 'File',align: 'left',value: 'name', width: '70%', sortable:false},
                {text: 'Created On',align: 'left',value: 'status',  width: '25%', sortable:false},
                {text: 'Delete',align: 'left',value: '',  width: '5%', sortable:false}
            ],
            message: null,
            attendance_corrections: null,
            original_attendance: null,
            dialogDelete: false,
            cutoff_details: null,
            dialogAttendanceCorrections: false,
            deleteAttendanceCorrectionsAttachmentId: null,
            attachments: [],
            deleteFunction: null,
            dialogTeamSelector: false,
            matchingTeams: []
        }
    },
    methods: {  
        deleteHandler() {
            if (typeof this.deleteFunction === 'function') {
                this.deleteFunction()
                this.dialogDelete = false
            }
        },
        showDeleteAttachment(data) {
            this.deleteAttendanceCorrectionsAttachmentId = data.attendanceCorrectionsAttachmentId
            this.$refs.refDeleteComponent.setMessage("Delete this attachment?")
            this.deleteFunction = () => this.deleteAttachment()
            this.dialogDelete = true
        },
        showDeleteAttendanceCorrections() {
            this.$refs.refDeleteComponent.setMessage("Delete this Attendance Correction request?")
            this.deleteFunction = () => this.deleteAttendanceCorrections()
            this.dialogDelete = true
        },
        async deleteAttachment() {
            try {
                this.loading_attachment = true
                const response = await attCorrectionsApi.deleteAttachment(this.deleteAttendanceCorrectionsAttachmentId)
                if (response && response.status == 200) {
                    await this.getAttendanceCorrectionsById(false)
                    this.loading_attachment = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showUpload(){
            this.dialogUpload = true
            this.$refs.uploadRef.setData(this.attendanceCorrectionsId)
        },
        async previewAttachment(item) {
            try {
                this.loading_attachment = true 
                const response = await attCorrectionsApi.getAttachmentUrl(this.attendance_corrections.userId, item.fileName)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.attendance_corrections.userId, response.data.fileName, AWSS3DocumentType.AttendanceCorrectionsAttachment)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_attachment = false
                    this.dialogPreview = true
                }
            }catch(error){
                console.log(error)
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        showAddEditAttCorrections() {
            const data = {
                    mode: 'Edit',
                    attendanceCorrectionsId: this.attendance_corrections.attendanceCorrectionsId,
                    transDate: this.attendance_corrections.transDate,
                    workshift: `${this.attendance_corrections.workShift} (${this.$moment(this.attendance_corrections.clockStart).format('h:mm a')} - ${this.$moment(this.attendance_corrections.clockEnd).format('h:mm a')})`,
                    clockStart: this.attendance_corrections.clockStart,
                    clockEnd: this.attendance_corrections.clockEnd,
                    clockIn: this.attendance_corrections.clockIn,
                    clockOut: this.attendance_corrections.clockOut,
                    remarks: this.attendance_corrections.remarks,
                    approvedOn: this.attendance_corrections.approvedOn,
                    attCorrectionsStatus: this.attendance_corrections.status,
                    updatedBy: this.attendance_corrections.updatedBy,
                    updatedByName: this.attendance_corrections.updatedByName,
                    updatedByRemarks: this.attendance_corrections.updatedByRemarks,
                    updatedOn: this.attendance_corrections.updatedOn,
                }    
                   
            this.$refs.addAttCorrections.setParams(data)
            this.dialogAttendanceCorrections = true
        }, 
        viewInMyAttendance() {
            this.$router.push(`/myattendance/daily/${this.$moment(this.attendance_corrections.transDate).format('YYYY-MM-DD')}`)
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    AttendanceCorrectionsId: this.attendanceCorrectionsId
                }
                const response = await attCorrectionsApi.forReview(data)
                if (response && response.status == 200) {
                    await this.getAttendanceCorrectionsById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    AttendanceCorrectionsId: this.attendanceCorrectionsId
                }
                const response = await attCorrectionsApi.approve(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getAttendanceCorrectionsById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    AttendanceCorrectionsId: this.attendanceCorrectionsId
                }
                const response = await attCorrectionsApi.reject(data, this.userPageKey)
                if (response && response.status == 200) {
                    await this.getAttendanceCorrectionsById(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        getWorkshiftType(strict) {
            if (strict) return '(Strict Shift)'
            return '(Flexible Shift)'
        },
        async deleteAttendanceCorrections() {
            try {
                this.loading_status = true
                var data = {
                    AttendanceCorrectionsId: this.attendanceCorrectionsId
                }
                const response = await attCorrectionsApi.delete(data)
                if (response && response.status == 200) {
                    this.loading_status = false
                    this.dialogDelete = false
                    this.$router.go(-1)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getAttendanceCorrectionsById(show_loading) {
            try {
                this.loading = show_loading
                const response = await attCorrectionsApi.getById(this.attendanceCorrectionsId, this.userPageKey)
                if (response && response.status == 200) {
                    if (response.data && response.data.correction) {
                        this.attendance_corrections = response.data.correction
                        this.original_attendance = response.data.originalAttendance
                        this.cutoff_details = response.data.cutoffItem
                        this.attachments = response.data.correction.attachments
                    }
                }
                this.loading = false
                this.dialogAttendanceCorrections = false
            }catch(error){
                console.log('error: ', error)
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getAttendanceCorrectionsById(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Attendance Corrections'
        })

        await this.getAttendanceCorrectionsById(true)

        if (this.attendance_corrections) {
            const result = await syncTeamContext(this.attendance_corrections.userId)
            if (result && result.action === 'SHOW_DIALOG') {
                this.matchingTeams = result.teams
                this.dialogTeamSelector = true
            }
        }
        
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path) ||
                hasTeamEditRights(AppPageID.TeamAttendanceCorrections)
        },
        hasTeamApproverRights() {
            return hasTeamApproverRights(AppPageID.TeamAttendanceCorrections)
        },
        hasTeamSelfApproverRights() {
            return hasTeamSelfApproverRights(AppPageID.TeamAttendanceCorrections)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        hasTeamDeleteRights() {
            return hasTeamDeleteRights(AppPageID.TeamAttendanceCorrections)
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasTeamApproverRights
        },
        isMenuDisabled() {
            return this.frozenPeriod || this.closedPeriod || this.approved_Timesheet
        },
        menuItems() {
            if (!this.attendance_corrections) return []

            const items = []

            // ACTION-BASED RULES
            const canEdit =
                this.hasEditRights &&
                (this.created_status || this.rejected_status)

            const canDelete =
                (this.hasDeleteRights || this.hasTeamDeleteRights) &&
                (this.created_status || this.rejected_status)

            const canForReview = this.hasEditRights && this.created_status

            const canApprove = this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.rejected_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.rejected_status)

            const canReject =  this.viewedByOwner ?
                this.hasTeamSelfApproverRights && (this.forReview_status || this.approved_status) :
                this.hasTeamApproverRights && (this.forReview_status || this.approved_status)

            // ORDER (match original UI)
            if (canEdit) {
                items.push({ label: 'Edit', action: this.showAddEditAttCorrections })
            }

            if (canForReview) {
                items.push({ label: 'For Review', action: this.setForReview })
            }

            if (canDelete) {
                items.push({ label: 'Delete', action: this.showDeleteAttendanceCorrections })
            }

            if (canApprove) {
                items.push({ label: 'Approve', action: this.approve })
            }

            if (canReject) {
                items.push({ label: 'Reject', action: this.reject })
            }

            return items
        },
        showMenu() {
            return !this.loading && this.attendance_corrections && this.menuItems && this.menuItems.length > 0
        },
        attendanceCorrectionsId() {
            return this.$route.params.attendanceCorrectionsId
        },
        viewedByOwner() {
            if (this.attendance_corrections) {
                return this.$store.state.userId == this.attendance_corrections.userId
            }
        },
        pageLink() {
            if (this.attendance_corrections) {
                if (this.viewedByOwner) {
                    if (this.$router.currentRoute.path.includes('company/corrections')) {
                        return `company${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }else{
                        return `myteam${this.$router.currentRoute.path.replace('/myattendance','')}`
                    }
                }else{
                    return `myattendance${this.$router.currentRoute.path.replace('/myteam','').replace('/company','')}`
                }
            }
        },
        commentsData() {
            //pageKey - will be used if posted by approver to retrieve page approvers if page owner does not have assigned supervisor
            if (this.attendance_corrections) {
                return {
                    pageQueryId: this.attendanceCorrectionsId,
                    pageItemCreatedBy: this.attendance_corrections.userId,
                    pageLink: this.pageLink,
                    pageKey: pageKeys.attendance_corrections_team_approver,
                    notificationTypeId: notificationTypes.attendance_corrections
                }
            }
        },
        userPageKey() {
            if (this.$router.currentRoute.path.includes('company/corrections')) {
                return pageKeys.attendance_corrections_company_approver
            }else if (this.$router.currentRoute.path.includes('myteam/corrections')) {
                return pageKeys.attendance_corrections_team_approver
            }else{
                return pageKeys.attendance_corrections
            }
        },
        frozenPeriod(){
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        },
        created_status() {
            if (this.attendance_corrections)
                return this.attendance_corrections.status==commonfn.getStatusCode('Created')
        },
        deleted_status() {
            if (this.attendance_corrections)
                return this.attendance_corrections.status==commonfn.getStatusCode('Deleted')
        },
        forReview_status() {
            if (this.attendance_corrections)
                return this.attendance_corrections.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.attendance_corrections)
                return this.attendance_corrections.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.attendance_corrections)
                return this.attendance_corrections.status==commonfn.getStatusCode('Rejected')
        },
        approved_Timesheet() {
            if (this.cutoff_details)
                return this.cutoff_details.timeReportStatus==commonfn.getStatusCode('Approved')
        },
        helpPageId() {
            if (this.viewedByOwner) {
                return 'attendance-corrections'
            }else{
                if (this.$router.currentRoute.path.includes('company/corrections')) {
                    return 'attendance-corrections-review-company'
                }else{
                    return 'attendance-corrections-review-team'
                }
            }
        },
        enableForEditRights() {
            return this.hasEditRights &&
                    !this.frozenPeriod &&
                    !this.closedPeriod &&
                    (this.created_status||this.rejected_status)
        }
    }
}
</script>
<style scoped>
.content-row-mobile {
    padding:0px 20px 0px 20px;
}
.content-row {
    padding:0px 20px 0px 50px;
}
.clickable:hover{
    text-decoration: underline;
}
</style>